import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { PATHS } from "../routes/paths";
import { criarCidade } from "../services/cidades";
import CidadeForm from "../components/Admin/CidadeForm/CidadeForm";
import "./AdminCidade.css";

export default function AdminCidadeNova() {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState("");

  const criarNovaCidade = async (form) => {
    setSaving(true);
    setSaveError("");

    try {
      const created = await criarCidade(form);
      navigate(PATHS.adminCidade.replace(":slug", created.slug), {
        state: { cidade: created, startEditing: true },
      });
    } catch (error) {
      setSaveError(
        error?.response?.data?.message ||
          "Não foi possível criar a cidade. Verifique os campos e tente novamente.",
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="admin-cidade admin-cidade--editing">
      <header className="admin-cidade__header">
        <Link to={PATHS.adminCidades}>← Todas as cidades</Link>
        <h1>NOVA CIDADE</h1>
        <p>Onde Estamos</p>
      </header>

      <section className="admin-cidade__editor" aria-label="Criar cidade">
        <CidadeForm
          onSubmit={criarNovaCidade}
          onCancel={() => navigate(PATHS.adminCidades)}
          submitting={saving}
        />
        {saveError && (
          <p className="admin-cidade__error" role="alert">
            {saveError}
          </p>
        )}
      </section>
    </div>
  );
}
